@if (!loading) {
  <div class="content flex-row pt-3">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <mat-card style="border-radius: 4px" class="image-card">

      <div class="profile-image-container">
        <img class="profile-image" [src]="profileImage" alt="Profile Image">
      </div>

      <mat-divider class="ml-2" style="width: 95%;"></mat-divider>

      <mat-card-content class="profile-card-content">
        <h1 class="xx-large-text provider-profile-title">{{serviceProviderProfileData?.businessName}}</h1>
      </mat-card-content>

    </mat-card>

    <div class="data">
      <mat-card style="border-radius: 4px" class="data-card card">
        <mat-card-title class="ml-3 provider-profile-bold-title pt-2">{{serviceProviderProfileData?.businessName + "'s "}}Information</mat-card-title>
        
        <mat-divider class="ml-3 mt-2" style="width: 95%;"></mat-divider>

        <div class="flex-row mt-4 data-card-info">
          <h1 class="ml-3 provider-profile-title">Location: </h1>
          <h3 class="mt-2 provider-profile-text" style="margin-left: 20px; min-width: 150px;">{{serviceProviderProfileData?.location}}</h3>
        </div>

        <mat-divider class="ml-3 mt-2" style="width: 95%;"></mat-divider>

        <div class="flex-row mt-4 mb-4 data-card-info">
          <h1 class="ml-3 provider-profile-title">Email: </h1>
          <h3 class="mt-1 provider-profile-text" style="margin-left: 20px; min-width: 150px;">{{serviceProviderProfileData?.email}}</h3>
        </div>
      </mat-card>

      <mat-card style="border-radius: 4px" class="bio-card card pt-2">
        <mat-card-title class="ml-3 provider-profile-bold-title">Bio</mat-card-title>
        <mat-divider class="ml-3" style="width: 95%;"></mat-divider>
        <p class="ml-3 provider-profile-text">{{serviceProviderProfileData?.bio}}</p>
      </mat-card>
    </div>
  </div>
}

<mat-divider class="mt-5 mb-2" style="width: 70%; margin-left: 12%;"></mat-divider>

<h1 class="provider-profile-title" style="text-align: center;">Shop {{serviceProviderProfileData?.businessName}}'s Service Plans</h1>

<div class="content shopping-card-content flex-row">
  @for (servicePlan of serviceProviderProfileData?.servicePlans; track servicePlan) {
    <mat-card style="border-radius: 4px" class="ml-2 mb-1 shopping-card">

      <mat-card-header class="ml-3" style="min-height: 150px;">
        <mat-card-title class="provider-profile-bold-title">{{servicePlan.serviceTypeModel?.name}}</mat-card-title>
        <mat-card-subtitle class="provider-profile-title">{{servicePlan.description}}</mat-card-subtitle>
      </mat-card-header>

      <mat-divider class="ml-2 mt-4" style="width: 95%;"></mat-divider>

      <mat-card-content class="ml-3 mt-3 mb-3 provider-profile-text">
        <p>Rate: ${{ servicePlan.rate.toFixed(2) }}</p>
        <p>Appointment Type: {{ servicePlan.appointmentType }}</p>
      </mat-card-content>

      <mat-divider class="ml-2" style="width: 95%;"></mat-divider>

      <mat-card-actions>
        <button (click)="navigateToShoppingPage(servicePlan.servicePlanId)" mat-raised-button style="border-radius: 4px" class="ml-3 mt-3" color="primary">Shop Now</button>
      </mat-card-actions>
    </mat-card>
  }
</div>
<footer class="mt-5"></footer>